var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Card } from '../card';
import { NotificationCard } from '../notification-card';
import { Paragraph } from '../paragraph';
import { ScreenReaderOnly } from '../screen-reader-only';
import { descriptionStaticStyle, titleStaticStyle, toastStaticStyle, } from './styles';
function CardInternal(_a) {
    var description = _a.description, onClose = _a.onClose, size = _a.size, title = _a.title, variant = _a.variant;
    function renderAnnouncement() {
        switch (variant) {
            case 'success':
                return _jsx(ScreenReaderOnly, { children: "Success:" });
            case 'warning':
                return _jsx(ScreenReaderOnly, { children: "Warning:" });
            case 'error':
                return _jsx(ScreenReaderOnly, { children: "Error:" });
            default:
                return null;
        }
    }
    return (_jsxs(NotificationCard, __assign({ closable: true, css: toastStaticStyle }, { onClose: onClose, size: size, variant: variant }, { children: [_jsxs(Card.Header, __assign({ as: "h2", css: titleStaticStyle, size: size }, { children: [renderAnnouncement(), title] })), description != null && (_jsx(Paragraph, __assign({ css: descriptionStaticStyle, size: size, variant: "secondary" }, { children: description })))] })));
}
export default CardInternal;
